package pl.michal_cyran.brand_hub.subpages.main.hero

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.icons.fa.FaTiktok
import com.varabyte.kobweb.silk.components.icons.fa.FaYoutube
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import pl.michal_cyran.brand_hub.SocialLinkStyle

@Composable
fun SocialLinks() {
    Row(modifier = Modifier.gap(12.px)) {
        SocialIconLink(
            path = "https://www.tiktok.com/@cyran_michal",
            icon = { size -> FaTiktok(size = size) }
        )
        SocialIconLink(
            path = "https://www.youtube.com/@cyran.michal",
            icon = { size -> FaYoutube(size = size) }
        )
    }
}

@Composable
private fun SocialIconLink(
    path: String,
    icon: @Composable (IconSize) -> Unit,
) {
    var hovered by remember { mutableStateOf(false) }

    Link(
        path = path,
        modifier = SocialLinkStyle.toModifier()
            .transform { scale(if (hovered) 1.15 else 1.0) }
            .transition(
                Transition.of("transform", 0.2.s, EaseOut, 0.ms)
            )
            .onMouseEnter { hovered = true }
            .onMouseLeave { hovered = false }
    ) {
        icon(IconSize.SM)
    }
}